:host {
    .step-container ul{
        list-style: none;
        display: flex;
        padding: 0px;
    }
    
}
